var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "navigation_icon",
    "data-name": "navigation icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23608",
    "data-name": "Group 23608",
    transform: "translate(-8 -7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1404",
    "data-name": "Ellipse 1404",
    transform: "translate(11 10.5)",
    fill: "none",
    stroke: "#003f85",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1405",
    "data-name": "Ellipse 1405",
    transform: "translate(16 15.5)",
    fill: "none",
    stroke: "#003f85",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23606",
    "data-name": "Group 23606",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y2: 3,
    transform: "translate(31 19.5) rotate(90)",
    fill: "none",
    stroke: "#003f85",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y2: 3,
    transform: "translate(12 19.5) rotate(90)",
    fill: "none",
    stroke: "#003f85",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23607",
    "data-name": "Group 23607"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 3,
    transform: "translate(20 8.5)",
    fill: "none",
    stroke: "#003f85",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y2: 3,
    transform: "translate(20 27.5)",
    fill: "none",
    stroke: "#003f85",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationicon);
export default __webpack_public_path__ + "static/media/navigation icon.f2caabdf4337d73a4b84733b5dd831e8.svg";
export { ForwardRef as ReactComponent };